module.exports = __webpack_public_path__ + "static/img/11.3e569f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/11.jpg
// module id = YkoJ
// module chunks = 0